import {
    availableBarsRestaurantsJobTypes,
    availableCastingJobTypes, availableEventSupportJobTypes,
    availableMasterOfCeremoniesJobTypes
} from '@/helpers/availableJobTypeHelper'

export default function () {
    return {
        event: {},
        jobStatuses: {
            0: 'Aguardando aceite',
            1: 'Job Aceito',
            2: 'Recusado',
            3: 'Cancelado',
            4: 'Sem Reposta',
            5: 'Indisponível',
            6: 'Indisponível',
            7: 'Cancelado',
            8: 'Cancelado'
        },
        allAvailableJobTypes: [
            ...availableCastingJobTypes,
            ...availableMasterOfCeremoniesJobTypes,
            ...availableEventSupportJobTypes,
            ...availableBarsRestaurantsJobTypes
        ],
        openMessages: null,
        showConfirmProfessionalFinderDialog: false,
        showConfirmResendInviteDialog: false,
        showInviteResentDialog: false,
        show: false,
        jobToReplace: null,
        jobToResend: null,
        showCloneErrorMessage: false,
        draftSelections: [],
    }
}
